module.exports = __webpack_public_path__ + "static/datadog-logo.feb3d97f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/datadog-logo.png
// module id = 116
// module chunks = 35783957827783 207353970745078